import React, { useState } from "react";
import Login from "../components/auth/login";
import Register from "../components/auth/register";

export default function Auth() {
  const [isLogin, setIsLogin] = useState(true);
  return (
    <div className="body-3d-bg d-flex flex-column align-items-center justify-content-center min-vh-100">
      <div className="card-3d">
        {isLogin ? <Login /> : <Register />}
      </div>
      <div className="switch-auth-row text-center mt-3">
        {isLogin ? (
          <>
            <span className="switch-auth-text">ليس لديك حساب؟ </span>
            <button className="switch-auth_btn" onClick={() => setIsLogin(false)}>
              أنشئ حساب
            </button>
          </>
        ) : (
          <>
            <span className="switch-auth-text">لديك حساب بالفعل؟ </span>
            <button className="switch-auth_btn" onClick={() => setIsLogin(true)}>
              تسجيل الدخول
            </button>
          </>
        )}
      </div>
    </div>
  );
}